/* eslint-disable */
import React,{useState} from 'react';
import 'contents/assets/scss/page/mypage.scss';
import Paging from '../../../component/Inc/Paging';
function CertificateRequest() {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <main className="com_container p_certificate">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu12_10'>증명서 요청</h2>
          <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_plus">증명서 요청</button>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className='com_board_list__top'>
              <section className='com_board_search end'>
                <article className='search'>
                  <input type="search" placeholder='검색할 내용을 입력해 주세요.' className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className='com_board_list'>
              <colgroup>
                <col width="13%"/><col />
                <col width="34%"/><col width="13%"/><col width="16%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>요청일</th>
                  <th>내용</th>
                  <th>요청 증명서</th>
                  <th>요청자</th>
                  <th>비고</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2022.08.25</td>
                  <td>이거 말고 다른 증명서가 필요합니다.</td>
                  <td>
                    <div className="com_btn_wrap certificate_wrap">
                      <span className="com_btn line orange xs">원천징수 영수증</span>
                      <span className="com_btn line orange xs">재직증명서</span>
                      <span className="com_btn line orange xs">보험증명서</span>
                    </div>
                  </td>
                  <td>홍길동103</td>
                  <td className='td_point'>답변 대기</td>
                </tr>
                <tr>
                  <td>2022.08.25</td>
                  <td>이거 말고 다른 증명서가 필요합니다.</td>
                  <td>
                    <div className="com_btn_wrap certificate_wrap">
                      <span className="com_btn line orange xs">원천징수 영수증</span>
                      <span className="com_btn empty">재직증명서</span>
                      <span className="com_btn line orange xs">보험증명서</span>
                    </div>
                  </td>
                  <td>홍길동103</td>
                  <td>관리자 <br />2022,09,25</td>
                </tr>
                <tr>
                  <td>2022.08.25</td>
                  <td>이거 말고 다른 증명서가 필요합니다.</td>
                  <td>
                    <div className="com_btn_wrap certificate_wrap">
                      <span className="com_btn empty">원천징수 영수증</span>
                      <span className="com_btn line orange xs">재직증명서</span>
                      <span className="com_btn line orange xs">보험증명서</span>
                    </div>
                  </td>
                  <td>홍길동103</td>
                  <td>관리자 <br />2022,09,25</td>
                </tr>
                <tr>
                  <td>2022.08.25</td>
                  <td>이거 말고 다른 증명서가 필요합니다.</td>
                  <td>
                    <div className="com_btn_wrap certificate_wrap">
                      <span className="com_btn empty">원천징수 영수증</span>
                      <span className="com_btn empty">재직증명서</span>
                      <span className="com_btn line orange xs">보험증명서</span>
                    </div>
                  </td>
                  <td>홍길동103</td>
                  <td>관리자 <br />2022,09,25</td>
                </tr>
                {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                  return (
                    <tr key={idx}>
                      <td>2022.08.25</td>
                      <td>이거 말고 다른 증명서가 필요합니다.</td>
                      <td>
                        <div className="com_btn_wrap certificate_wrap">
                          <span className="com_btn line orange xs">원천징수 영수증</span>
                          <span className="com_btn line orange xs">재직증명서</span>
                          <span className="com_btn line orange xs">보험증명서</span>
                        </div>
                      </td>
                      <td>홍길동103</td>
                      <td>관리자 <br />2022,09,25</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <p>댓글 <span className="cnt">10</span></p>
                <span className="dot" />
                <p>조회 <span className="cnt">321</span></p>
              </div>
            </div>
            <div className="com_input_wrap">
              <textarea className="textarea" placeholder='증명서 발급 요청 드립니다.'></textarea>
              <div className="com_info_box__wrap">
              <div className="com_info_box">
                <strong className="tit_info_box">근로자</strong>
                <ul className="check">
                  <li className='item'>
                    <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                    <label htmlFor="chk01">원천징수 영수증</label>
                  </li>
                  <li className='item'>
                    <input type="checkbox" name="chk" id="chk02" className="com_chk" />
                    <label htmlFor="chk02">재직 증명서</label>
                  </li>
                  <li className='item'>
                    <input type="checkbox" name="chk" id="chk03" className="com_chk" />
                    <label htmlFor="chk03">보험증명서</label>
                  </li>
                  <li className='item'>
                    <input type="checkbox" name="chk" id="chk04" className="com_chk" />
                    <label htmlFor="chk04">기타 증명서</label>
                  </li>
                </ul>
              </div>
              <div className="com_info_box">
                <strong className="tit_info_box">프리랜서</strong>
                <ul className="check">
                  <li className='item'>
                    <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                    <label htmlFor="chk01">위촉증명서</label>
                  </li>
                  <li className='item'>
                    <input type="checkbox" name="chk" id="chk02" className="com_chk" />
                    <label htmlFor="chk02">해촉증명서</label>
                  </li>
                  <li className='item'>
                    <input type="checkbox" name="chk" id="chk03" className="com_chk" />
                    <label htmlFor="chk03">경력증명서</label>
                  </li>
                  <li className='item'>
                    <input type="checkbox" name="chk" id="chk04" className="com_chk" />
                    <label htmlFor="chk04">기타 증명서</label>
                  </li>
                </ul>
              </div>
              
            </div>
            </div>
            <div className="com_info_box">
              <strong className="tit_info_box">수령방법</strong>
              <ul className="check row">
                <li className="item">
                  <input type="radio" name="radio" id="radio01" className="com_chk circle" />
                  <label htmlFor="radio01">팩스</label>
                </li>
                <li className="item">
                  <input type="radio" name="radio" id="radio02" className="com_chk circle" />
                  <label htmlFor="radio02">이메일</label>
                </li>
                <li className="item">
                  <input type="radio" name="radio" id="radio03" className="com_chk circle" />
                  <label htmlFor="radio03">직접수령</label>
                </li>
              </ul>
              <input type="text" className="input" placeholder="- 없이 팩스번호 입력"></input>
            </div>
            <div className="com_btn_wrap center">
              <div className="com_btn orange s wl">요청하기</div>
            </div>
            <div className="com_comment_wrap type_board">
              <ul className="comment_list">
              {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                return (
                  <li className="item" key={idx}>
                    <div className="info">
                      <p className="name">홍길동104</p>
                      <span className="dot" />
                      <p className="date">2023.05.20 11:30</p>
                      <div className="com_btn_wrap">
                        <button className="btn_edit"></button>
                        <button className="btn_delete"></button>
                      </div>
                    </div>
                    <p className="txt">
                      축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!<br />
                      축하드려요~!
                    </p>
                  </li>
                  )
                })}
              </ul>
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder='댓글을 입력해주세요' />
                <button className="com_btn gray l">등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default CertificateRequest;
